import React, { Component, Fragment } from 'react';
import { Card, Tag, Row, Col, Avatar, Icon } from 'antd';
import { inject, observer } from 'mobx-react/index';
import moment from 'moment-timezone';

@inject('store')
@observer
export class AutoDCAView extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.store.botStore.getAutoDCALogs();
    }

    render() {
        if (!this.props.store.botStore.currentConfiguration) return null;
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={24}>
                        <Card title={`Auto Dollar Cost Averaging Journal`} bordered={false}>
                            {this.props.store.botStore.autoDCALogs.map((o, i) => {
                                return (
                                    <Card
                                        key={i}
                                        bordered={false}
                                        title={
                                            <span>
                                                <Avatar
                                                    width={'24px'}
                                                    src={`/symbols/${o.baseId}.png`}
                                                />{' '}
                                                {o.baseId}
                                            </span>
                                        }
                                        extra={this.getType(o.action)}
                                        size={'small'}
                                        style={{ marginBottom: 10 }}
                                    >
                                        <b>Created: </b>
                                        {moment(o.created_at)
                                            .tz(timezone)
                                            .format('MMMM Do YYYY, h:mm:ss a')}
                                        <br />
                                        <b>Position:</b> {o.position_id}
                                        <br />
                                        {o.message ? (
                                            <Fragment>
                                                <b>Log:</b> {o.message}
                                            </Fragment>
                                        ) : null}
                                        {this.renderSignals(o.indicators)}
                                    </Card>
                                );
                            })}
                        </Card>
                    </Col>
                </Row>
            </Fragment>
        );
    }

    renderSignals(group) {
        if (!group) return null;

        if (group.error) {
            return <div>{group.message}</div>;
        }

        if (!group.signal) return;
        return group.signal.signals.map((signal, i) => {
            if (!signal) {
                return null;
            }

            return (
                <div key={i} style={{ marginTop: 8 }}>
                    {signal.fired ? (
                        <Icon
                            type="check-circle"
                            theme="filled"
                            style={{ color: '#436b45', marginRight: 5 }}
                        />
                    ) : (
                        <Icon
                            type="close-circle"
                            theme="filled"
                            style={{ color: '#ba7272', marginRight: 5 }}
                        />
                    )}
                    {signal.a_label}: <Tag>{signal.a}</Tag>
                    {this.getClause(signal.clause)}
                    {signal.b_label}: <Tag>{signal.b}</Tag>
                </div>
            );
        });
    }

    getType(type) {
        switch (type) {
            case 'dca_buy':
                return 'Buy';
            case 'buy_signal':
                return 'Buy';
            case 'fail':
                return 'Error';
            default:
                return null;
        }
    }

    getClause(clause) {
        switch (clause) {
            case 'eq':
                return 'Equals';
            case 'lt':
                return 'Less than';
            case 'lte':
                return 'Less than or equals';
            case 'gt':
                return 'Greater than';
            case 'gte':
                return 'Greater than or equals';
            case 'cross_above':
                return 'Cross above';
            case 'cross_below':
                return 'Cross below';
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/AutoDCAView/index.js